import { motion } from 'motion/react';
import { snappyTween, staggerEntrance } from './motionUi';

function itemIconIsUrl(icon) {
  const s = String(icon || '').trim();
  return s.startsWith('http://') || s.startsWith('https://') || s.startsWith('/') || s.startsWith('data:');
}

/**
 * Inventory viewer �� shows all non-Gift items; owned are unlocked, others show price.
 */
export default function GameInventoryModal({
  itemsCatalog = [],
  ownedItemIds = [],
  playerTokens = 0,
  onPurchase,
  onClose
}) {
  const ownedSet = new Set(ownedItemIds.map(String));
  const nonGiftItems = itemsCatalog.filter((it) => it.type !== 'Gift');

  if (nonGiftItems.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 p-8">
        <p className="text-sm text-game-muted">No items in the shop yet.</p>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4">
        {nonGiftItems.map((item, i) => {
          const owned = ownedSet.has(String(item._id));
          const iconUrl = itemIconIsUrl(item.icon);
          const canAfford = playerTokens >= (item.cost || 0);

          return (
            <motion.div
              key={item._id}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={staggerEntrance(i, 0.05, 0)}
              className={`relative flex flex-col items-center overflow-hidden rounded-2xl border p-4 shadow-md ${
                owned
                  ? 'border-game-accent/30 bg-game-surface'
                  : 'border-white/10 bg-game-surface/60'
              }`}
            >
              <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-xl border border-white/10 bg-game-canvas/80 text-3xl">
                {iconUrl ? (
                  <img src={item.icon} alt="" className="h-12 w-12 object-contain" draggable={false} />
                ) : (
                  <span>{item.icon || '📦'}</span>
                )}
              </div>
              <p className="text-center text-xs font-semibold text-game-text">{item.name}</p>
              {item.description ? (
                <p className="mt-0.5 line-clamp-2 text-center text-[10px] text-game-muted">{item.description}</p>
              ) : null}
              <p className="mt-1 text-center text-[9px] font-medium italic text-game-muted/70">
                {item.type === 'MistressDildo' ? 'For Dominant characters' : 'For Submissive characters'}
              </p>

              {owned ? (
                <span className="mt-2 rounded-md bg-game-accent/20 px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-game-accent">
                  Owned
                </span>
              ) : (
                <>
                  {onPurchase ? (
                    <motion.button
                      type="button"
                      transition={snappyTween}
                      whileHover={{ scale: canAfford ? 1.03 : 1 }}
                      whileTap={{ scale: canAfford ? 0.97 : 1 }}
                      disabled={!canAfford}
                      onClick={() => onPurchase(item)}
                      className="mt-2 w-full rounded-xl border border-game-accent/40 bg-game-accent/10 py-2 text-[11px] font-bold text-game-accent transition-colors hover:bg-game-accent/20 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      {canAfford ? `Buy · ${item.cost || 0} ◆` : 'Not enough ◆'}
                    </motion.button>
                  ) : null}
                </>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
